export interface InconsistencyFile {
  recordDocumentId?: string;
  fileId?: number;
  name: string;
  sizeBytes: number;
  url?: string;
  isUploading?: boolean;
  tempId?: string;
}

export interface Inconsistency5SFilesBucket {
  files: InconsistencyFile[];
  loading: boolean;
  error: string | null;
}

export interface Inconsistency5SFilesState {
  [inconsistencyId: number]: Inconsistency5SFilesBucket;
}

export enum Inconsistency5SFilesActionTypes {
  FETCH_REQUEST = 'inconsistency5SFiles/FETCH_REQUEST',
  FETCH_SUCCESS = 'inconsistency5SFiles/FETCH_SUCCESS',
  FETCH_FAILURE = 'inconsistency5SFiles/FETCH_FAILURE',

  UPLOAD_REQUEST = 'inconsistency5SFiles/UPLOAD_REQUEST',
  UPLOAD_SUCCESS = 'inconsistency5SFiles/UPLOAD_SUCCESS',
  UPLOAD_FAILURE = 'inconsistency5SFiles/UPLOAD_FAILURE',

  DELETE_REQUEST = 'inconsistency5SFiles/DELETE_REQUEST',
  DELETE_SUCCESS = 'inconsistency5SFiles/DELETE_SUCCESS',
  DELETE_FAILURE = 'inconsistency5SFiles/DELETE_FAILURE',
}

export interface FetchFilesRequestAction {
  type: Inconsistency5SFilesActionTypes.FETCH_REQUEST;
  payload: { inconsistencyId: number; inconsistencyDocumentId: string };
}

export interface FetchFilesSuccessAction {
  type: Inconsistency5SFilesActionTypes.FETCH_SUCCESS;
  payload: { inconsistencyId: number; files: InconsistencyFile[] };
}

export interface FetchFilesFailureAction {
  type: Inconsistency5SFilesActionTypes.FETCH_FAILURE;
  payload: { inconsistencyId: number; error: string };
}

export interface UploadFileRequestAction {
  type: Inconsistency5SFilesActionTypes.UPLOAD_REQUEST;
  payload: { inconsistencyId: number; file: File; tempId: string };
}

export interface UploadFileSuccessAction {
  type: Inconsistency5SFilesActionTypes.UPLOAD_SUCCESS;
  payload: { inconsistencyId: number; tempId: string; file: InconsistencyFile };
}

export interface UploadFileFailureAction {
  type: Inconsistency5SFilesActionTypes.UPLOAD_FAILURE;
  payload: { inconsistencyId: number; tempId: string; error: string };
}

export interface DeleteFileRequestAction {
  type: Inconsistency5SFilesActionTypes.DELETE_REQUEST;
  payload: { inconsistencyId: number; recordDocumentId: string; fileId?: number };
}

export interface DeleteFileSuccessAction {
  type: Inconsistency5SFilesActionTypes.DELETE_SUCCESS;
  payload: { inconsistencyId: number; recordDocumentId: string };
}

export interface DeleteFileFailureAction {
  type: Inconsistency5SFilesActionTypes.DELETE_FAILURE;
  payload: { inconsistencyId: number; recordDocumentId: string; error: string };
}

export type Inconsistency5SFilesActions =
  | FetchFilesRequestAction
  | FetchFilesSuccessAction
  | FetchFilesFailureAction
  | UploadFileRequestAction
  | UploadFileSuccessAction
  | UploadFileFailureAction
  | DeleteFileRequestAction
  | DeleteFileSuccessAction
  | DeleteFileFailureAction;
